import { useEffect, useState } from "react";
import { useT, useI18n } from "../../i18n/I18nProvider";
import { api } from "../../lib/api";
import type { AccountUser } from "../../lib/auth";
import { ConnectedAppsCard } from "./security/ConnectedAppsCard";
import { PasswordCard } from "./security/PasswordCard";
import { ConnectedAccountsCard } from "./security/ConnectedAccountsCard";
import { PasskeysCard } from "./security/PasskeysCard";
import { MfaCard } from "./security/MfaCard";
import { SessionsCard } from "./security/SessionsCard";
import { AuditCard } from "./security/AuditCard";
import type { SessionRow, AuditRow } from "./security/lib";

export function SecuritySection({ user }: { user: AccountUser }) {
  const t = useT();
  const { locale } = useI18n();
  const [sessions, setSessions] = useState<SessionRow[]>([]);
  const [audit, setAudit] = useState<AuditRow[]>([]);

  async function reload() {
    setSessions(await api.get<SessionRow[]>("/account/sessions").catch(() => []));
    setAudit(await api.get<AuditRow[]>("/account/audit").catch(() => []));
  }
  useEffect(() => {
    void reload();
  }, []);

  return (
    <div className="space-y-6">
      <PasswordCard user={user} onChanged={reload} />
      <ConnectedAccountsCard user={user} />
      <PasskeysCard />
      <MfaCard onChanged={reload} />
      <ConnectedAppsCard />
      <SessionsCard sessions={sessions} onChange={reload} />
      <AuditCard audit={audit} locale={locale} t={t} />
    </div>
  );
}
